module.exports = __webpack_public_path__ + "static/media/rolling.c9b019a6.svg";